import manageGroupHeaderHtml from './manageGroupHeaderComponent.html';

export default {
  controllerAs: 'ctrl',
  templateUrl: manageGroupHeaderHtml,
  transclude: {
    header: 'groupHeader',
    actions: 'multiselectActions',
  },
  bindings: {
    isSomethingSelected: '<',
    simpleActions: '<',
  },
};
